<div class="flex flex-col space-y-2 md:p-4">

  <div class="grid grid-cols-3 grid-cols-[10%_30%_60%] md:grid-cols-[10%_50%_40%]
  mr-0.5 md:mr-0 overflow-hidden">
    <a routerLink="/dashboard">
      <div class="pt-4 h-8 w-8" id="balance-back-arrow">
      </div>
    </a>
    <div><h1 class="pt-2.5">Energie-Bilanz</h1></div>

    <div class="mb-4 flex justify-center items-center space-x-2 bg-gray-100 rounded-md mr-2 md:mr-0 w-auto overflow-hidden">

      @if (this.selectedInterval() === 'day') {
        <app-day-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-day-datepicker>
      }

      @if (this.selectedInterval() === 'month') {
        <app-month-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-month-datepicker>
      }

      @if (this.selectedInterval() === 'year') {
        <app-year-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-year-datepicker>
      }

    </div>
  </div>
</div>

<div class="flex flex-col space-y-2 md:p-4">
  <mat-button-toggle-group [value]="selectedInterval()" (change)="onIntervalSelectionChange($event)"
                           class="flex justify-center md:border-1 border-0 border-t border-b border-l-0 border-r-0
                           rounded-none md:rounded-lg border-gray-200">
    <mat-button-toggle value="day" class="flex-1 border-gray-200">
      Tag
    </mat-button-toggle>
    <mat-button-toggle value="month" class="flex-1 border-gray-200">
      Monat
    </mat-button-toggle>
    <mat-button-toggle value="year" class="flex-1 border-gray-200">
      Jahr
    </mat-button-toggle>
    <mat-button-toggle value="total" class="flex-1 border-gray-200">
      Gesamt
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div class="infotext pt-4 pb-8 p-4">Dieses Diagramm veranschaulicht, wohin die erzeugte Energie geflossen ist und aus
    welchen Quellen sie stammt. Die durch die Produktion generierte Energiemenge ist in beiden Balken identisch.
    <!--<a href="/energy-balance" class="underline">Mehr erfahren.</a>-->
  </div>

  @if (this.selectedInterval() === 'day') {
    <app-daily-energy-balance [date]="selectedDate()"></app-daily-energy-balance>
  }

  @if (this.selectedInterval() === 'month') {
    <app-monthly-energy-balance [date]="selectedDate()"></app-monthly-energy-balance>
  }

  @if (this.selectedInterval() === 'year') {
    <app-yearly-energy-balance [date]="selectedDate()"></app-yearly-energy-balance>
  }
  @if (this.selectedInterval() === 'total') {
    <app-total-energy-balance [date]="selectedDate()"></app-total-energy-balance>
  }

</div>
